import requests from "./httpService";

const UserServices = {

    getPrivicyPolicy : async () =>{
        return requests.get(`/app/?data=privacyPolicy`);
    },
    updateAppPolicy : async (body) =>{
        return requests.patch(`/app/`,body);
    },

    getTermCondition : async () =>{
        return requests.get(`/app/?data=termsAndCondition`);
    },

    getAboutus : async () =>{
        return requests.get(`/app/?data=about`);
    },
    
    getCancel : async () =>{
        return requests.get(`/app/`);
    },
    getRefer: async () =>{
        return requests.get(`/refer/`);
    },
    updateRefer : async (id,body) =>{
     
        return requests.patch(`/refer/${id}`,body);
    },
    getNumberOfBooking: async () =>{
        return requests.get(`/numberbooking/`);
    },
    updateNumberOfBooking : async (id,body) =>{
      
        return requests.patch(`/numberbooking/${id}`,body);
    }

}

export default UserServices;